/// <amd-module name="Agile/Taskboard/CustomColumn/State/CustomColumnContracts" />

export interface IColumn {
    id: string;
    name: string;
    order: number;
    error?: string;
    stateMappingError?: string; // Error message for any state mappings
    isNew?: boolean;
}

export interface IWorkItemTypeStateStatus {
    stateNameKey: string;
    error?: string;
}

export type ColumnToStateMap = { [columnId: string]: { [workItemTypeNameKey: string]: IWorkItemTypeStateStatus } };

// This is copied from agile-common as we don't want to take dependency on redux
export enum WorkItemStateCategory {
    Proposed = 1000,
    InProgress = 2000,
    Resolved = 3000,
    Completed = 4000,
    Removed = 5000
}

export type WorkItemTypeToStateMap = { [workItemTypeNameKey: string]: { [state: string]: WorkItemStateCategory } };

export interface ICustomColumnState {
    columns: IColumn[];
    normalizedTaskWorkItemTypesToStateMap: WorkItemTypeToStateMap;
    normalizedColumnIdToWorkItemTypeStateMap: ColumnToStateMap;
    selectedColumnIndex: number;
    saving?: boolean;
    savingError?: Error; // Error message when save failed
    addNewColumnFailed: boolean; // When adding new column fails because of the limit
    isDirty: boolean;
    isValid: boolean;
    unmappedStateKeys: { [workItemTypeNameKey: string]: string[] };
    witKeyNameMap: { [workItemTypeKey: string]: string /** workItemType Name */ };
    stateKeyNameMap: { [stateKey: string]: string /** state */ };
}

export const MAX_COLUMN_LIMIT = 50;
